import { render } from "./SigninView.vue?vue&type=template&id=094c5c44"
import script from "./SigninView.vue?vue&type=script&lang=js"
export * from "./SigninView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__